const initialState = {
    selected_manufacturer_roles: [],
    show_gst_input: false,
    gst_details: null,
    pan_details: null,
    gst_flow: true,
    gst_number: null,
    operational_details: null,
    existingFirm: false
};

const FirmOnboardingReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_EXISTING_FIRM':
      return {
        ...state,
        existingFirm: action.payload
      };
    case 'ADD_MANUFACTURER_ROLE':
      return {
        ...state,
        selected_manufacturer_roles: [...state.selected_manufacturer_roles, action.payload]
      };
    case 'UPDATE_MANUFACTURER_ROLE':
      return {
        ...state,
        selected_manufacturer_roles: state.selected_manufacturer_roles.map(item => 
          item.manufacturer_id === action.payload.manufacturer_id ? action.payload : item
        )
      };
    case 'REMOVE_MANUFACTURER_ROLE':
      return {
        ...state,
        selected_manufacturer_roles: state.selected_manufacturer_roles.filter(
          item => item.manufacturer_id !== action.payload
        )
      };
    case 'REPLACE_MANUFACTURER_ROLES':
      return {
        ...state,
        selected_manufacturer_roles: action.payload
      };
    case 'SET_MANUFACTURER_ROLES':
      return {
        ...state,
        selected_manufacturer_roles: action.payload
      };
    case 'SET_SHOW_GST_INPUT':
      return {
        ...state,
        show_gst_input: action.payload
      };
    case 'SET_GST_FLOW':
      return {
        ...state,
        gst_flow: action.payload
      };
    case 'SET_GST_DETAILS':
      return {
        ...state,
        gst_details: action.payload
      };
    case 'SET_OPERATIONAL_DETAILS':
      return {
        ...state,
        operational_details: action.payload
      };
    case 'UPDATE_OPERATIONAL_DETAILS':
      return {
        ...state,
        operational_details: {
          ...state.operational_details,
          ...action.payload
        }
      };
    case 'SET_PAN_DETAILS':
      return {
        ...state,
        pan_details: action.payload
      };
    case 'RESET_OPERATIONAL_DETAILS': 
      return {
        ...state,
        operational_details: null
      };
    case 'RESET_PAN_DETAILS':
      return {
        ...state,
        pan_details: null
      };
    case 'SET_GST_NUMBER':
      return {
        ...state,
        gst_number: action.payload
      };
    case 'RESET_FIRM_ONBOARDING':
      return {
        ...initialState,
        selected_firm: action.payload,
      };
    default:
      return state;
  }
};

export default FirmOnboardingReducer;